import { DispatchedRow } from "features/iot/stock-management/models/stock-management-models"
import sensorBatchStore from "features/iot/sensor-batch/stores/sensor-batch-store"
import { getDispatched } from "../stock-managment/stock-management-helper"
import customerStore from "features/organizations/customers/store/customer-store"

export function groupSensorBatchesDispatchedRows(partNumber: string): DispatchedRow[] {
    try {
        const sensors = sensorBatchStore.getAllSensors()
        if (!partNumber || !sensors) return []

        const filteredSensors = getDispatched(partNumber)
        if (!filteredSensors) return []

        const allocationsMap: Record<string, DispatchedRow> = {}

        filteredSensors.forEach(sensor => {
            if (sensor.dispatched) {
                const customerName = customerStore.getCustomerNameById(sensor.customerId) || "unknown"
                const siteName = customerStore.getSiteNameById(sensor.siteId) || "unknown"
                const key = `${customerName}-${siteName}`

                allocationsMap[key] = allocationsMap[key] || {
                    id: sensor.macAddress,
                    customer: customerName,
                    site: siteName,
                    quantity: 0,
                }

                allocationsMap[key].quantity += 1
            }
        })

        return sortDispatchedRows(Object.values(allocationsMap))
    } catch (e) {
        console.error("Error in groupSensorBatchesDispatchedRows:", e)
        return []
    }
}

function sortDispatchedRows(allocations: DispatchedRow[]): DispatchedRow[] {
    return allocations.sort((a, b) => {
        // Compare customers
        if (a.customer === null) return 1 // nulls last
        if (b.customer === null) return -1 // nulls last
        if (a.customer < b.customer) return -1
        if (a.customer > b.customer) return 1

        // If customers are equal, compare sites
        if (a.site === null) return 1 // nulls last
        if (b.site === null) return -1 // nulls last
        if (a.site < b.site) return -1
        if (a.site > b.site) return 1

        return 0 // equal
    })
}
